import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {LoginGuard} from 'guards/login.guard';
import {ConstructsOverviewComponent} from './constructs-overview.component';

const routes: Routes = [
  {path: 'constructs', component: ConstructsOverviewComponent, canActivate: [LoginGuard]},
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
  providers: [],
})

export class ConstructsOverviewRoutingModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/constructs/constructs-overview/constructs-overview-routing.module.ts